import { useQuery } from '@tanstack/react-query';
import { getEmailLeadSettings } from '../services/api/implementation/impl';
import {
  EMAIL_LEAD_SETTINGS_QUERY_KEY,
  hasActiveMailbox,
  mailboxesNeedingAttention
} from '../utils/emailLeadsAccess';

/**
 * Connected portal mailboxes.
 *
 * Shared by the Integration card and the Email Leads page so both read one
 * cache entry. `retry: false` because a 403 here means "your role cannot see
 * this" and a 400 means the feature is off — both normal states, neither worth
 * retrying.
 */
export function useEmailLeadSettings({ enabled = true } = {}) {
  const query = useQuery({
    queryKey: EMAIL_LEAD_SETTINGS_QUERY_KEY,
    queryFn: getEmailLeadSettings,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled
  });

  return {
    ...query,
    mailboxes: query.data?.mailboxes ?? [],
    connected: !query.isError && (query.data?.mailboxes?.length ?? 0) > 0,
    active: !query.isError && hasActiveMailbox(query.data),
    needsAttention: query.isError ? [] : mailboxesNeedingAttention(query.data),
    canManageMailbox: query.data?.canManageMailbox === true,
    canManageSources: query.data?.canManageSources === true,
    portals: query.data?.portals ?? [],
    imapPresets: query.data?.imapPresets ?? [],
    minConfidence: query.data?.minConfidence ?? 0.6
  };
}

export default useEmailLeadSettings;
